export default "__VITE_ASSET__ed394a77__"